import { PermissionValues as Permissions } from '@gripp/shared-logic';
import { Activities } from './components/activities';
import { ActivityEdit } from './components/activity-edit';
import { ActivityReassign } from './components/activity-reassign';

export const activityPaths = {
  root: 'activities',
};

export const activityRoutes = [
  {
    path: `${activityPaths.root}/*`,
    element: <Activities />,
    handle: {
      header: {
        titleKey: 'activity.menu.title',
        icon: 'bell-outline',
      },
      requiredPermission: Permissions.activity.all,
    },
    children: [
      {
        path: ':issueId',
        element: <></>,
      },
      {
        path: ':issueId/asset/:assetId',
        element: <></>,
      },
    ],
  },
  {
    path: `${activityPaths.root}/:issueId/edit`,
    element: <ActivityEdit />,
    handle: {
      header: {
        titleKey: 'activity.menu.title',
        icon: 'bell-outline',
      },
      requiredPermission: Permissions.activity.all,
    },
  },
  {
    path: `${activityPaths.root}/:issueId/reassign`,
    element: <ActivityReassign />,
    handle: {
      header: {
        titleKey: 'activity.menu.title',
        icon: 'bell-outline',
      },
      requiredPermission: Permissions.activity.all,
    },
  },
];
